import {createConsumer, Consumer} from '@rails/actioncable';
import Utility from './Utility';

class ActionCable {
  static #consumer: null | Consumer = null;

  static get consumer() {
    if (!this.#consumer) {
      this.#consumer = createConsumer(Utility.BASE_URL + '/cable');
    }
    return this.#consumer;
  }

  static get subscriptions() {
    return this.consumer.subscriptions;
  }
}

export default ActionCable;
